/* SDSS WORK responsive tables; does not change saved page content. */
(function(){
  function init(){
    var roots=document.querySelectorAll('#MainContent.sdss-content--page .rte, #MainContent.sdss-content--collection .rte, #MainContent.sdss-content--product .rte');
    var wrappers=[];
    roots.forEach(function(root){
      root.querySelectorAll('table').forEach(function(table){
        if(table.closest('.sdss-table-scroll')||!table.parentNode)return;
        var wrapper=document.createElement('div');
        wrapper.className='sdss-table-scroll';
        table.parentNode.insertBefore(wrapper,table);
        wrapper.appendChild(table);
        wrappers.push(wrapper);
      });
    });
    if(!wrappers.length)return;
    function update(){
      wrappers.forEach(function(wrapper){
        var overflow=wrapper.scrollWidth>wrapper.clientWidth+2;
        if(overflow){
          wrapper.tabIndex=0;
          wrapper.setAttribute('role','region');
          wrapper.setAttribute('aria-label','Tabella scorrevole orizzontalmente');
        }else{
          wrapper.removeAttribute('tabindex');
          wrapper.removeAttribute('role');
          wrapper.removeAttribute('aria-label');
        }
      });
    }
    update();
    window.addEventListener('resize',update,{passive:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
